// extracted by mini-css-extract-plugin
export default {"accordion__main":"Faq_accordion__main__jnMDo"};